module.exports = __webpack_public_path__ + "img/beijing2.1114c3ae.png";